<template>    
        <b-icon :icon="v ? 'check-circle-fill':'circle'" @click="toggle" :class="{clickable:!readonly}" :variant="readonly ? 'secondary' : 'primary'"></b-icon>
</template>
<script>
    
    export default {
        name: 'lformselect',
        props: [ 'value', 'readonly' ],
        data() {
            return {
                v:null,                
            }
        },
        created() {
            this.v = this.value;
        },
        watch: {
            value: function () {
                this.v = this.value;
            }
        },
        computed: {
            
        },
        methods: {
            toggle() {
                if(!this.readonly) {
                    this.v = !this.v;
                    this.input();
                }
            },
            input() {
                this.$emit('input', this.v);
                this.$emit('change', this.v);
            }
        }
    }

</script>